"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconSelected = void 0;
var React = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var IconSelected = function (props) {
    var theme = styled_components_1.useTheme();
    return (React.createElement("svg", __assign({ width: "24px", height: "24px", viewBox: "0 0 24 24" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            React.createElement("rect", { id: "Padding", x: 0, y: 0, width: 24, height: 24 }),
            React.createElement("g", { id: "Selected", transform: "translate(2.000000, 2.000000)" },
                React.createElement("path", { d: "M10,0.5 C12.6231875,0.5 14.9981827,1.56341443 16.7173841,3.28261589 C18.4365856,5.00181735 19.5,7.3768125 19.5,10 C19.5,12.6231875 18.4365856,14.9981827 16.7173841,16.7173841 C14.9981827,18.4365856 12.6231875,19.5 10,19.5 C7.3768125,19.5 5.00181735,18.4365856 3.28261589,16.7173841 C1.56341443,14.9981827 0.5,12.6231875 0.5,10 C0.5,7.3768125 1.56341443,5.00181735 3.28261589,3.28261589 C5.00181735,1.56341443 7.3768125,0.5 10,0.5 Z", id: "Check", fill: !!theme ? (theme.name !== 'privalia' ? theme.colors.main.base : theme.colors.red.s75) : '#EC008C' }),
                React.createElement("path", { d: "M14.1285421,5.37166621 L7.18176229,11.6831785 L5.92536594,9.16807399 C5.6289668,8.71305508 4.99056866,8.566799 4.50097008,8.84181043 C4.0101715,9.11682186 3.85297196,9.70934648 4.1493711,10.1643654 L6.09096546,14.533297 C6.25536498,14.7858075 6.53736416,14.9558145 6.85416324,14.990816 C6.89616312,14.9958162 6.936963,14.9970662 6.97896288,14.9970662 C7.25256208,14.9970662 7.51656132,14.8970621 7.71216075,14.7170546 L15.5961378,6.57296614 C16.0017367,6.1967005 16.1733362,5.5879252 15.7689373,5.21165957 C15.3633385,4.83539393 14.5341409,4.99540058 14.1285421,5.37166621", id: "Fill-3", fill: "#FFFFFF" })))));
};
exports.IconSelected = IconSelected;
exports.IconSelected.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconSelected;
